class Index {
    rc;
    _parent;
    timezoneId;
    constructor(_parent, timezoneId = null) {
        this._parent = _parent;
        this.rc = _parent.rc;
        this.timezoneId = timezoneId;
    }
    path(withParameter = true) {
        if (withParameter && this.timezoneId !== null) {
            return `${this._parent.path()}/timezone/${this.timezoneId}`;
        }
        return `${this._parent.path()}/timezone`;
    }
    /**
     * Returns all available timezones.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/dictionary/timezone
     * Rate Limit Group: Light
     */
    async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns information on a certain timezone.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/dictionary/timezone/{timezoneId}
     * Rate Limit Group: Light
     */
    async get(restRequestConfig) {
        if (this.timezoneId === null) {
            throw new Error("timezoneId must be specified.");
        }
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
